export const paymentPaidCreditTransactionSelector = (state: any) => {
  return state.SettingReducer.creditTransaction;
};

export const paymentPaidCreditUsageSelector = (state: any) => {
  return state.SettingReducer.creditUsage;
};
